import React from "react";
import UserAvatar from "react-user-avatar";

interface IProps {
  photo: string;
  first_name: string;
  second_name: string;
  patronymic: string;
  points: number;
  order_price: number;
}

const Referals: React.SFC<IProps> = ({ ...props }) => {
  return (
    <div className="d-flex justify-content-between mb-3 ref-block_mobile">
      <div className="ref__img">
        <UserAvatar size="43" name={`${props.first_name} ${props.second_name}`} src={props.photo} alt="" />
      </div>
      <div className="ref__deal">
        <ul className="d-none d-md-block hmm pl-0 mb-0">
          <li>
            <span>{`${props.second_name} ${props.first_name} ${
              props.patronymic
            }`}</span>
            <strong>{props.order_price} ₽</strong>
          </li>
        </ul>
        <div className="d-none d-md-flex justify-content-between">
          <span className="ref__deal-span"/>
          <span className="ref__deal-span ref__deal-span-mobile">Гонорар: {props.points} Бал.</span>
        </div>
        <div className="d-flex d-md-none justify-content-between">
          <span className="ref-se-span">
            {props.second_name}
            <br /> {props.first_name}
            <br /> {props.patronymic}
          </span>
          <div className="text-right">
            <span className="d-block ref-se-span color-grey">10.12.2018</span>
            <span className="d-block ref-se-span">{props.order_price} ₽</span>
            <span className="d-block ref-se-span color-grey">
              Гонорар: {props.points}
            </span>
          </div>
        </div>
      </div>
      <div className="kromka d-md-none"></div>
    </div>
  );
};

export default Referals;
